import { css } from 'emotion';

export const titleWrapper = css`
  display: flex;
  width: 29%;
`;

export const titleIconWrapper = css`
  margin-right: 10px;
`;

export const titleTextWrapper = css`
  display: flex;
  flex-direction: column;
`;

export const subtitle = css`
  margin-top: 10px;
`;

export const contentHeadersWrapper = css`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 1em;
`;

export const contentHeaderWrapper = (numEntries: number) => css`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: ${90 / numEntries || 90}%;

  &:not(:first-child) {
    margin-left: 20px;
  }

  > span:first-of-type {
    margin: auto 0;
  }

  > span:not(:first-of-type) {
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    max-width: 69%;
  }
`;

export const contentHeaderSubtitle = css`
  margin-left: 10px;
`;

export const contentHeaderIcon = css`
  margin-right: -15px;
  margin-bottom: 2px;
`;

export const lastContent = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  width: 10%;
`;
